<div class="log-viewer border-0">
  <div class="log-header bg-warning border-0">
    <div class="header-left">
      <span class="title text-dark">
        <i class="fas fa-terminal me-2"></i>
        System Logs
      </span>
      <span class="badge bg-dark ms-2" *ngIf="isLiveMode && !isPaused"
        >LIVE</span
      >
      <span class="badge bg-danger ms-2" *ngIf="isPaused">PAUSED</span>
    </div>
    <div class="header-center">
      <div
        class="mode-toggle btn-group shadow-sm bg-white p-1"
        style="border-radius: 6px"
      >
        <button
          class="btn btn-sm border-0 d-flex justify-content-center align-items-center"
          [style.background-color]="isLiveMode ? '#212529' : 'transparent'"
          [style.color]="isLiveMode ? '#fff' : '#212529'"
          [style.border-radius]="isLiveMode ? '4px' : ''"
          (click)="toggleLiveMode('live')"
          style="min-width: 80px"
        >
          <i class="fas fa-bolt me-1"></i> Live
        </button>
        <button
          class="btn btn-sm border-0 d-flex justify-content-center align-items-center"
          [style.background-color]="!isLiveMode ? '#212529' : 'transparent'"
          [style.color]="!isLiveMode ? '#fff' : '#212529'"
          [style.border-radius]="!isLiveMode ? '4px' : ''"
          (click)="toggleLiveMode('history')"
          style="min-width: 80px"
        >
          <i class="fas fa-history me-1"></i> History
        </button>
      </div>
    </div>
    <div class="header-right">
      <div class="date-select" *ngIf="!isLiveMode && availableDates.length > 0">
        <select
          class="form-select form-select-sm border-0 shadow-sm text-dark bg-white"
          [value]="selectedDate"
          (change)="onDateChange($event)"
        >
          <option *ngFor="let date of availableDates" [value]="date">
            {{ date }}
          </option>
        </select>
      </div>
      <div class="search-box">
        <input
          type="text"
          class="form-control form-control-sm border-0 shadow-sm text-dark bg-white"
          placeholder="Search logs..."
          [(ngModel)]="searchTerm"
          (ngModelChange)="onSearchChange()"
        />
        <button
          *ngIf="searchTerm"
          class="btn-search-clear text-dark"
          (click)="clearSearch()"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="live-controls" *ngIf="isLiveMode">
        <button
          class="btn btn-sm border-0 text-dark"
          [class.bg-white]="isPaused"
          [class.shadow-sm]="isPaused"
          (click)="togglePause()"
          [title]="isPaused ? 'Resume' : 'Pause'"
        >
          <i
            class="fas"
            [class.fa-play]="isPaused"
            [class.fa-pause]="!isPaused"
          ></i>
        </button>
        <button
          class="btn btn-sm border-0 text-dark"
          [class.bg-white]="autoScroll"
          [class.shadow-sm]="autoScroll"
          (click)="toggleAutoScroll()"
          title="Auto-scroll"
        >
          <i class="fas fa-arrow-down"></i>
        </button>
      </div>
      <button
        class="btn btn-sm border-0 text-danger"
        (click)="clearLogs()"
        [title]="
          isLiveMode ? 'Clear live logs' : 'Clear logs for selected date'
        "
      >
        <i class="fas fa-trash-alt"></i>
      </button>
      <button
        class="btn btn-sm border-0 text-dark"
        (click)="downloadLogs()"
        title="Download logs"
      >
        <i class="fas fa-download"></i>
      </button>
      <span class="ms-2 clickable" (click)="dialogRef.close()">
        <i
          class="fa fa-times p-2 py-1 shadow bg-light"
          style="border-radius: 5px"
        ></i>
      </span>
    </div>
  </div>

  <div class="log-content position-relative" #logContainer>
    <div class="loading-overlay" *ngIf="isLoading">
      <div class="spinner-border text-warning" role="status"></div>
      <span class="mt-2" style="font-size: 14px; font-weight: 500"
        >Fetching logs...</span
      >
    </div>
    <!-- Live Mode -->
    <ng-container *ngIf="isLiveMode">
      <div *ngIf="cachedFilteredLiveLogs.length === 0" class="empty-state">
        <i class="fas fa-rss fa-2x mb-3"></i>
        <p>Waiting for logs...</p>
        <small class="text-muted">Logs will appear here in real-time</small>
      </div>
      <div
        class="log-entry"
        *ngFor="let log of cachedFilteredLiveLogs; trackBy: trackByLogId"
        [ngStyle]="getLiveLogStyle(log.level)"
      >
        <div class="log-meta">
          <span class="log-time">{{ log.formattedTime }}</span>
          <div class="log-indicators">
            <span class="log-count-badge" *ngIf="log.count && log.count > 1">{{
              log.count
            }}</span>
            <span
              class="log-source"
              [ngClass]="'source-' + log.source?.toLowerCase()"
              >{{ log.source }}</span
            >
            <span class="log-level" [ngClass]="'level-' + log.level">{{
              log.level
            }}</span>
          </div>
        </div>
        <div class="log-message-container">
          <span
            class="log-message"
            [class.collapsed]="log.isLong && !log.isExpanded"
            >{{ log.message }}</span
          >
          <button
            class="btn btn-link btn-sm p-0 text-muted ms-2 toggle-btn"
            *ngIf="log.isLong"
            (click)="log.isExpanded = !log.isExpanded"
          >
            {{ log.isExpanded ? "Show less" : "Show more" }}
          </button>
        </div>
      </div>
    </ng-container>

    <!-- History Mode -->
    <ng-container *ngIf="!isLiveMode">
      <div *ngIf="cachedFilteredHistoryLogs.length === 0" class="empty-state">
        <i class="fas fa-inbox fa-2x mb-3"></i>
        <p>No logs available</p>
        <small class="text-muted" *ngIf="searchTerm"
          >No matches found for "{{ searchTerm }}"</small
        >
      </div>
      <div
        class="log-entry"
        *ngFor="let item of cachedFilteredHistoryLogs; trackBy: trackByLogId"
        [ngStyle]="getLiveLogStyle(item.level)"
      >
        <div class="log-meta">
          <span class="log-time">{{ item.formattedTime }}</span>
          <div class="log-indicators">
            <span
              class="log-count-badge"
              *ngIf="item.count && item.count > 1"
              >{{ item.count }}</span
            >
            <span
              class="log-source"
              [ngClass]="'source-' + item.source?.toLowerCase()"
              >{{ item.source }}</span
            >
            <span class="log-level" [ngClass]="'level-' + item.level">{{
              item.level
            }}</span>
          </div>
        </div>
        <div class="log-message-container">
          <span
            class="log-message"
            [class.collapsed]="item.isLong && !item.isExpanded"
            [ngStyle]="getLogStyle(item.originalLine)"
          >
            {{ item.message }}
          </span>
          <button
            class="btn btn-link btn-sm p-0 text-muted ms-2 toggle-btn"
            *ngIf="item.isLong"
            (click)="item.isExpanded = !item.isExpanded"
          >
            {{ item.isExpanded ? "Show less" : "Show more" }}
          </button>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="log-footer">
    <span class="log-count" *ngIf="isLiveMode">
      {{ cachedFilteredLiveLogs.length }} entries
      <span *ngIf="searchTerm"> (filtered)</span>
    </span>
    <span class="log-count" *ngIf="!isLiveMode">
      {{ cachedFilteredHistoryLogs.length }} entries from {{ selectedDate }}
    </span>
  </div>
</div>
